
import PageTitle from '../components/pagetitle/PageTitle'; 

const TermsOfUse = () => {
  return (
    <div>
      <PageTitle pageTitle="Legal" pagesub="Terms of Use" />
       

      <div className="container">
        
          <div className=" pp-content">

            <p className="pp-meta">
              Effective Date: <strong>1 March 2023</strong> &nbsp;·&nbsp; Last Updated: <strong>26 March 2026</strong>
            </p>

            <p>
              Please read these Terms of Use carefully before using this website or engaging our
              services. By accessing printprinters.com or submitting a quote or order request, you
              agree to be bound by these Terms. If you do not agree, please do not use this website
              or our services.
            </p>

            <h2>1. About These Terms</h2>
            <p>
              These Terms of Use govern your access to and use of the website at printprinters.com
              ("the Website") and the printing and related services ("the Services") provided by
              Print Printers, a division of Citicap Channels Pvt. Ltd., a company registered in
              New Delhi, India ("Print Printers", "we", "us" or "our").
            </p>
            <p>
              These Terms apply to all visitors, users and clients of the Website and Services.
              Additional terms may apply to specific services or projects and will be communicated
              to you at the time of engagement.
            </p>
            <p>
              We reserve the right to update or modify these Terms at any time. Changes will be
              effective immediately upon posting to the Website. Your continued use of the Website
              or Services following any change constitutes your acceptance of the updated Terms.
              We encourage you to review these Terms periodically.
            </p>

            <h2>2. Use of the Website</h2>

            <h3>2.1 Permitted Use</h3>
            <p>You may use this Website for lawful purposes only and in accordance with these Terms. Specifically, you are permitted to:</p>
            <ul>
              <li>Browse information about our printing services and capabilities</li>
              <li>Submit quote requests and project enquiries</li>
              <li>Download publicly available resources such as our capability profile</li>
              <li>Contact us through the forms and contact details provided</li>
            </ul>

            <h3>2.2 Prohibited Use</h3>
            <p>You must not use this Website to:</p>
            <ul>
              <li>Violate any applicable law or regulation</li>
              <li>Transmit any unsolicited or unauthorised advertising or promotional material</li>
              <li>Transmit any material that is defamatory, offensive, obscene or otherwise objectionable</li>
              <li>Attempt to gain unauthorised access to any part of the Website or its related systems</li>
              <li>Interfere with or disrupt the integrity or performance of the Website</li>
              <li>Introduce any viruses, trojans, worms, logic bombs or other harmful material</li>
              <li>Use automated tools to scrape, harvest or extract data from the Website without our prior written consent</li>
              <li>Misrepresent your identity or affiliation with any person or organisation</li>
            </ul>

            <h2>3. Quote Requests and Orders</h2>

            <h3>3.1 Nature of Quote Requests</h3>
            <p>
              Submitting a quote request through our Website, email or any other channel does not
              constitute a binding order or contract. A quote request is an invitation for us to
              prepare and submit a pricing proposal. No contract for services is formed until we
              have issued a formal written quote, you have confirmed your acceptance in writing,
              and we have confirmed acceptance of your order.
            </p>

            <h3>3.2 Accuracy of Information</h3>
            <p>
              You are responsible for ensuring that all information provided in connection with a
              quote request or order is accurate, complete and not misleading. This includes but
              is not limited to specifications such as page count, trim size, paper stock,
              quantities, binding type, finishing requirements, delivery address and required
              timelines. We are not liable for errors, delays or additional costs arising from
              inaccurate or incomplete information provided by you.
            </p>

            <h3>3.3 Pricing and Quotations</h3>
            <p>All prices quoted by Print Printers are:</p>
            <ul>
              <li>Valid for 10 days from the date of issue unless otherwise stated</li>
              <li>Subject to change if specifications change after the quote is issued</li>
              <li>Exclusive of any applicable taxes, import duties or customs charges at the destination unless explicitly stated otherwise</li>
              <li>Provided in the currency specified in the quote and subject to exchange rate fluctuations where applicable</li>
            </ul>
            <p>We reserve the right to withdraw or revise a quote at any time before formal acceptance.</p>

            <h3>3.4 Order Confirmation</h3>
            <p>
              An order is confirmed only when both parties have exchanged written confirmation of
              the specifications, price, quantities and delivery timeline, and Print Printers has
              received the agreed advance payment or deposit where applicable. We reserve the
              right to decline any order at our discretion.
            </p>

            <h3>3.5 Proofs and Approvals</h3>
            <p>
              A physical proof will be produced and shipped to the address specified by you prior
              to commencement of the full production run, unless you have explicitly waived this
              requirement in writing. Production will not begin until the physical proof has been
              approved by you in writing. Print Printers is not responsible for errors, colour
              variations or quality issues that were present in the approved proof and carried
              through to the finished print run.
            </p>

            <h3>3.6 Changes to Orders</h3>
            <p>
              Any changes to an order after confirmation must be submitted in writing. Changes may
              affect pricing, timelines and minimum quantities. Changes cannot be accepted once
              production has commenced unless agreed in writing by Print Printers.
            </p>

            <h2>4. Intellectual Property</h2>

            <h3>4.1 Client Files and Content</h3>
            <p>
              You retain all intellectual property rights in the files, designs, text, images and
              other content you supply to us in connection with your print job ("Client
              Materials"). By providing Client Materials to us, you grant Print Printers a
              limited, non-exclusive licence to use those materials solely for the purpose of
              producing and delivering your print order. We will not use your Client Materials
              for any other purpose without your prior written consent.
            </p>

            <h3>4.2 Warranties Regarding Client Materials</h3>
            <p>By providing Client Materials to Print Printers, you warrant that:</p>
            <ul>
              <li>You own or have the necessary rights and licences to all content included in the Client Materials</li>
              <li>The Client Materials do not infringe the intellectual property rights, privacy rights or any other rights of any third party</li>
              <li>The Client Materials do not contain any content that is unlawful, defamatory, obscene or otherwise objectionable</li>
              <li>You have obtained all necessary permissions from any individuals whose image, name or personal information appears in the Client Materials</li>
            </ul>
            <p>
              You agree to indemnify and hold Print Printers harmless from and against any claims,
              damages, losses and expenses arising from any breach of these warranties.
            </p>

            <h3>4.3 Print Printers Intellectual Property</h3>
            <p>
              All content on this Website, including text, graphics, logos, images, design
              templates, process documentation and capability materials, is the property of Print
              Printers or its licensors and is protected by applicable intellectual property laws.
              You may not reproduce, distribute, modify or create derivative works from any
              Website content without our prior written consent, except as expressly permitted
              by law.
            </p>

            <h3>4.4 Confidentiality</h3>
            <p>
              Both parties agree to keep confidential all non-public information disclosed by the
              other party in connection with a quote or order. Print Printers will not disclose
              your project specifications, content, pricing or business information to any third
              party except to the extent necessary to fulfil your order (e.g. to our production
              partners or freight forwarders), and only under binding confidentiality obligations.
            </p>

            <h2>5. Payment Terms</h2>
            <p>Unless otherwise agreed in writing, the following payment terms apply:</p>
            <ul>
              <li>A deposit of 50% of the total order value is required upon order confirmation to commence production</li>
              <li>The remaining balance is due prior to dispatch of the finished goods, or as otherwise specified in the order confirmation</li>
              <li>Payment methods and currencies are as agreed at the time of order confirmation</li>
              <li>Late payments may attract interest charges at a rate to be notified to you at the time</li>
              <li>Print Printers reserves the right to withhold delivery of goods until full payment is received</li>
            </ul>
            <p>
              All prices are quoted exclusive of applicable taxes unless expressly stated. You are
              responsible for all import duties, customs charges and destination taxes applicable
              in your country of delivery.
            </p>

            <h2>6. Delivery and Shipping</h2>

            <h3>6.1 Sailing and Transit Times</h3>
            <p>
              Estimated sailing and transit times provided by Print Printers are indicative only
              and are not guaranteed. Actual delivery times may vary due to factors outside our
              control including weather, port congestion, customs clearance delays, public
              holidays or force majeure events. Print Printers is not liable for delays caused
              by such factors.
            </p>

            <h3>6.2 Delivery Terms</h3>
            <p>
              Unless otherwise agreed, delivery is provided on a door-to-door basis from our
              press in New Delhi to the address specified in your order. We can also deliver on
              ex-works terms (FOB New Delhi) at your request. Risk in the goods passes to you
              upon delivery to the carrier at our agreed point of dispatch.
            </p>

            <h3>6.3 Short Deliveries and Overs</h3>
            <p>
              Print Printers reserves the right to deliver up to 10% more or fewer copies than
              the quantity ordered ("overs" and "unders") unless you have specified otherwise in
              writing. In such cases, the invoice will be adjusted pro-rata to reflect the actual
              quantity delivered. If you require an exact quantity with no overs or unders, this
              must be specified at the time of ordering.
            </p>

            <h3>6.4 Inspection and Claims</h3>
            <p>
              You must inspect all goods promptly upon receipt. Any claim for damaged, defective
              or short-delivered goods must be submitted to us in writing within 14 days of the
              delivery date, accompanied by photographic evidence where applicable. Claims
              submitted after this period may not be accepted. Print Printers will not be liable
              for damage that occurs after delivery.
            </p>

            <h2>7. Quality and Returns</h2>
            <p>
              We are committed to producing high-quality printed goods that match your approved
              proof. If the finished goods materially fail to conform to your approved proof
              specifications, you must notify us in writing within 5 days of delivery with
              specific details of the non-conformance.
            </p>
            <p>
              Where a valid quality claim is accepted by Print Printers, we will at our option
              either reprint the affected goods at our cost or provide an appropriate credit or
              refund. We will not be responsible for:
            </p>
            <ul>
              <li>Minor colour variations within industry-standard tolerances (typically within ±5% of the approved proof)</li>
              <li>Variations resulting from the inherent properties of the paper stock or materials specified by you</li>
              <li>Issues arising from errors in the Client Materials that were present in the approved proof</li>
              <li>Damage caused by improper storage, handling or use after delivery</li>
            </ul>

            <h2>8. Limitation of Liability</h2>
            <p>
              This section limits our legal liability to you. Please read it carefully. To the
              fullest extent permitted by applicable law:
            </p>
            <ul>
              <li>Print Printers' total liability to you in connection with any order or claim shall not exceed the total amount paid by you for the specific order giving rise to the claim</li>
              <li>Print Printers shall not be liable for any indirect, consequential, special, incidental or punitive damages, including but not limited to loss of profits, loss of business, loss of revenue, loss of data or reputational harm, even if we have been advised of the possibility of such damages</li>
              <li>Print Printers shall not be liable for losses arising from your failure to provide accurate specifications, approve proofs in a timely manner, or comply with these Terms</li>
              <li>Print Printers shall not be liable for delays or failures in performance caused by circumstances outside our reasonable control (see Section 10 — Force Majeure)</li>
            </ul>
            <p>
              Nothing in these Terms limits our liability for death or personal injury caused by
              our negligence or any other liability that cannot be excluded or limited under
              applicable law.
            </p>

            <h2>9. Warranties and Disclaimers</h2>
            <p>
              The Website is provided on an "as is" and "as available" basis. To the fullest
              extent permitted by law, Print Printers makes no representations or warranties of
              any kind regarding:
            </p>
            <ul>
              <li>The accuracy, completeness or currency of information on the Website</li>
              <li>The uninterrupted or error-free operation of the Website</li>
              <li>The fitness of the Website or its content for any particular purpose</li>
            </ul>
            <p>
              We reserve the right to modify, suspend or discontinue the Website or any part of
              it at any time without notice.
            </p>

            <h2>10. Force Majeure</h2>
            <p>
              Print Printers shall not be liable for any failure or delay in performing its
              obligations where such failure or delay results from circumstances beyond its
              reasonable control, including but not limited to acts of God, war, civil unrest,
              terrorism, fire, flood, earthquake, epidemic, pandemic, strikes or other industrial
              action, government restrictions, port closures, customs delays or failure of
              third-party suppliers or carriers.
            </p>
            <p>
              In the event of a force majeure event, we will notify you as soon as reasonably
              practicable and will use reasonable endeavours to resume performance as soon as the
              circumstances permit. If a force majeure event continues for more than 60 days,
              either party may terminate the affected order by written notice without further
              liability, other than for amounts already paid.
            </p>

            <h2>11. Termination and Cancellation</h2>
            <p>
              You may cancel a confirmed order by written notice to{' '}
              <a href="mailto:print@printprinters.com">print@printprinters.com</a>.
              Cancellation fees apply as follows:
            </p>
            <ul>
              <li><strong>Before production has commenced</strong> — 25% of the total order value as an administration and commitment fee</li>
              <li><strong>After production has commenced but before completion</strong> — the full cost of work completed to date, including materials, press time and labour</li>
              <li><strong>After production is complete</strong> — the full order value, plus any additional costs incurred for storage or logistics</li>
            </ul>
            <p>
              Print Printers reserves the right to terminate an order or suspend Services
              immediately if you breach these Terms and fail to remedy the breach within 7 days
              of written notice, or if you become insolvent or subject to insolvency proceedings.
            </p>

            <h2>12. Governing Law and Dispute Resolution</h2>
            <p>
              These Terms and any dispute or claim arising in connection with them shall be
              governed by and construed in accordance with the laws of India. The courts of
              New Delhi, India shall have exclusive jurisdiction to settle any dispute arising
              out of or in connection with these Terms, subject to the following:
            </p>
            <p>
              Before initiating any formal legal proceedings, both parties agree to attempt to
              resolve any dispute through good-faith negotiation for a period of 30 days from
              the date of written notice of the dispute. If the dispute cannot be resolved
              through negotiation, either party may refer the matter to a mutually agreed
              mediator before resorting to litigation.
            </p>
            <p>
              If you are a consumer in the United Kingdom, European Union or Australia, you may
              also have rights to refer disputes to alternative dispute resolution schemes or
              national consumer protection bodies under applicable law in your jurisdiction.
            </p>

            <h2>13. Privacy</h2>
            <p>
              Your use of this Website and our Services is also governed by our Privacy Policy,
              which is incorporated into these Terms by reference. Please review our Privacy
              Policy at printprinters.com to understand how we collect, use and protect your
              personal information.
            </p>

            <h2>14. Severability</h2>
            <p>
              If any provision of these Terms is found to be invalid, unlawful or unenforceable
              by a court of competent jurisdiction, that provision shall be deemed severed from
              the remainder of the Terms, which shall continue in full force and effect.
            </p>

            <h2>15. Entire Agreement</h2>
            <p>
              These Terms, together with any specific order confirmation, formal quote and our
              Privacy Policy, constitute the entire agreement between you and Print Printers with
              respect to your use of the Website and the Services, and supersede all prior
              agreements, representations or understandings between the parties.
            </p>

            <h2>16. Contact Us</h2>
            <p>
              If you have any questions about these Terms of Use or wish to raise a concern,
              please contact us:
            </p>
            <p>
              <strong>Email:</strong>{' '}
              <a href="mailto:print@printprinters.com">print@printprinters.com</a><br />
              <strong>Phone India:</strong> +91 11 4304 3388<br />
              <strong>Phone USA:</strong> +1 202 470 0880<br />
              <strong>Address:</strong> Citicap Channels Pvt. Ltd., New Delhi, India<br />
              <strong>Website:</strong> printprinters.com
            </p>
            <p>We aim to respond to all enquiries within 5 working days.</p>

          </div>
        </div>
      
    </div>
  );
};

export default TermsOfUse;